import React from 'react';

export interface SearchHighlightTextProps {
  text: string;
  search: string;
  style: React.CSSProperties; // style of highlighted text
}

const SearchHighlightText: React.FC<SearchHighlightTextProps> = ({
  text,
  search,
  style,
}) => {
  // should be case insensitive
  const matches = Array.from(
    text.matchAll(new RegExp(search, 'gi')),
    m => m[0]
  );

  if (matches.length === 0 || search.length === 0) return <div>{text}</div>;

  const plainText = text.split(new RegExp(search, 'gi'));

  return (
    <div>
      {matches.map((match, index) => {
        return (
          <React.Fragment key={index}>
            <span>{plainText[index]}</span>
            <span style={style}>{match}</span>
          </React.Fragment>
        );
      })}
      <span>{plainText.length > 1 && plainText[plainText.length - 1]}</span>
    </div>
  );
};
export default SearchHighlightText;
